import { useMutation } from "react-query";

import { buildFormDataPayload } from "../../helpers/api";
import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

type ConfirmWillSourceVehiclePayload = {
  driverVehicleQuoteFile: File | null;
};

export const confirmWillSourceVehicle = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    defaultOnMutateSettled,
  } = useAPQuery();

  return useMutation({
    mutationFn: (payload: ConfirmWillSourceVehiclePayload): Promise<string> => {
      return fetchWithAuth<string>("confirmWillSourceVehicle", dossierId, {
        requestOptions: {
          method: "post",
          body: buildFormDataPayload(payload, ["driverVehicleQuoteFile"]),
          excludeContentTypeHeader: true,
        },
      });
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
    onSettled: () => defaultOnMutateSettled([["dossier", dossierId]]),
  });
};
